/* Darween — interactions thème */

(function () {
  'use strict';

  // Collection filters (client-side filtering by data-style)
  const filterContainer = document.querySelector('[data-filters]');
  if (filterContainer) {
    const filters = filterContainer.querySelectorAll('.specimens__filter, .collection-grid__filter');
    const cards = document.querySelectorAll('.specimen-card, .product-card');

    filters.forEach((btn) => {
      btn.addEventListener('click', () => {
        filters.forEach((f) => f.classList.remove('is-active'));
        btn.classList.add('is-active');
        const target = btn.dataset.filter;
        cards.forEach((card) => {
          if (target === 'all' || card.dataset.style === target) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  // Product gallery — thumb switching
  const thumbs = document.querySelectorAll('.product__thumb');
  const mainImage = document.getElementById('ProductMainImage');
  if (mainImage && thumbs.length > 0) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        const full = thumb.dataset.full;
        if (full) mainImage.src = full;
        else {
          const thumbImg = thumb.querySelector('img');
          if (thumbImg) mainImage.src = thumbImg.src.replace(/_120x/, '_1200x');
        }
      });
    });
  }
})();
